import { GA4Event } from '@jusbrasil-web/shared-ga4-events'
import { useGTM } from '@jusbrasil-web/shared-gtm'
import { useCallback } from 'react'

import { GA4UserProperties } from './GA4UserProperties'

export type GA4Dispatcher = {
  sendGA4Event: (event: GA4Event) => void
  setGA4UserProperties: (userProperties: GA4UserProperties) => void
}

export function useGA4Dispatcher(): GA4Dispatcher {
  const gtm = useGTM()

  const sendGA4Event = useCallback(
    (event: GA4Event) => {
      if (process.env.NODE_ENV === 'development') {
        const caller = new Error().stack
          ?.split('\n')
          .slice(2)
          .find((line) => !line.includes('use-ga4-dispatcher.ts'))

        console.log('sent to ga4:', event, 'from:', caller?.trim() ?? 'unknown')
      }
      gtm.push({ ...event })
    },
    [gtm]
  )

  const setGA4UserProperties = useCallback(
    (userProperties: GA4UserProperties) => gtm.push({ ...userProperties }),
    [gtm]
  )

  return {
    sendGA4Event,
    setGA4UserProperties,
  } satisfies GA4Dispatcher
}
